import { h, Component } from 'preact';
import s from 'components/media/addMedia.sss';
import { onFileInput } from 'utils/media';
import { canUser } from 'utils/roles';

import Button from 'components/button/button';

export default class AddMedia extends Component {
	constructor(props) {
		super(props);
		this.handleFileInput = this.handleFileInput.bind(this);
	}

	async handleFileInput(e) {
		e.preventDefault();
		onFileInput(e.target.files, this.props.group, this.base.closest('dialog'));
		e.target.value = null;
	}

	getAcceptedFileTypes() {
		let types = [];

		// TODO: constrolled via props
		const allowImages = true;
		if (allowImages) {
			// Specifying both mime types and extensions, as recommended in the HTML spec
			types.push(
				'image/png', '.png',
				'image/jpeg', '.jpg', '.jpeg',
				'image/webp', '.webp',
			);
		}

		// TODO: constrolled via props
		const allowVideos = true;
		if (allowVideos) {
			types.push(
				'video/mp4', '.mp4',
				'video/webm', '.webm',
			);
		}

		return types.join(',');
	}

	render() {
		return (
			<Button tag="label" class={s.button} primary icon="plus">
				<input type="file" accept={this.getAcceptedFileTypes()} onInput={this.handleFileInput} multiple disabled={!canUser('upload')} />
				Add media
			</Button>
		);
	}
}